import DatePickerFilter from 'components/Functional/Filters/DatePickerFilter';
import MobileBaseFilters from 'components/Functional/Filters/MobileFilter/MobileBaseFilters';
import FilterDropdown from 'components/Functional/Filters/FilterDropdown';
import SelectedFilters from 'components/Functional/ArticleFilterBar/SelectedFilters';

export type Filter = {
  id: string;
  options: FilterOption[];
};

type FilterOption = {
  id: string;
  applied: boolean;
  selected: boolean;
  numberOfSelected: number;
  aggregateCount: number | null;
};

type Props = {
  filters: Filter[];
  isFetching: boolean;
  showDatePicker: boolean;
  filterApply: () => void;
  unApplyOptions: (option) => void;
  onOptionSelect: () => void;
  needAggregateCount: (filterId) => void;
  className: string;
  appliedOptions: FilterOption[];
  allOptions: FilterOption[];
  selectedOptions: FilterOption[];
  onResetUnAppliedOptions: () => void;
  onClearFilterSelection: () => void;
};

const BaseFilter = ({
  filters,
  showDatePicker = false,
  filterApply,
  className = '',
  needAggregateCount,
  onOptionSelect,
  allOptions,
  onResetUnAppliedOptions,
  onClearFilterSelection,
  isFetching,
  unApplyOptions,
  appliedOptions,
  selectedOptions,
}: Props) => {
  return allOptions.length || showDatePicker ? (
    <div className={`filters-box ${className}`}>
      {/* @ts-expect-error quick workaround */}
      <MobileBaseFilters
        className="d-lg-none mobile-filters-button"
        filters={filters}
        isFetching={isFetching}
        appliedOptions={appliedOptions}
        allOptions={allOptions}
        showDatePicker={showDatePicker}
        needAggregateCount={needAggregateCount}
        optionSelect={onOptionSelect}
        resetUnAppliedOptions={onResetUnAppliedOptions}
        filterApply={filterApply}
        clearFilters={() => unApplyOptions(null)}
        selectedOptions={selectedOptions}
      />
      <div className="filters-group d-none d-lg-flex align-items-top">
        {showDatePicker && <DatePickerFilter inline={false} />}
        {filters.map((filter) => (
          <FilterDropdown
            key={filter.id}
            filter={filter}
            onClearFilterSelection={onClearFilterSelection}
            resetUnAppliedOptions={onResetUnAppliedOptions}
            needAggregateCount={() => needAggregateCount(filter.id)}
            filterApply={filterApply}
            isFetching={isFetching}
            optionSelect={onOptionSelect}
          />
        ))}
      </div>
      {appliedOptions.length !== 0 && (
        <SelectedFilters
          className="mt-4"
          appliedFilterOptions={appliedOptions}
          onDeleteOption={unApplyOptions}
          onClearFilters={() => unApplyOptions(null)}
        />
      )}
    </div>
  ) : null;
};

export default BaseFilter;
